import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  COUNT_STATUSES,
  type CountFilters,
  type CountStatus,
} from '@/features/inventory-counts/api'
import { CountsScreen } from '@/features/inventory-counts/counts-screen'
import { hasGrant } from '@/lib/me'

const text = (value: unknown) => (typeof value === 'string' && value ? value : undefined)
const positive = (value: unknown) => {
  const number =
    typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : Number.NaN
  return Number.isInteger(number) && number > 0 ? number : undefined
}

export const Route = createFileRoute('/_authenticated/inventory/counts/')({
  validateSearch: (search: Record<string, unknown>): CountFilters => ({
    status: COUNT_STATUSES.find((status: CountStatus) => status === search.status),
    warehouse: text(search.warehouse),
    mine: search.mine === true || search.mine === 'true' ? true : undefined,
    q: text(search.q),
    page: positive(search.page),
    perPage: positive(search.perPage),
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock_count.view')) throw redirect({ to: '/' })
  },
  component: InventoryCountsRoute,
})

function InventoryCountsRoute() {
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <CountsScreen
      params={Route.useSearch()}
      onParamsChange={(next) => void navigate({ search: next })}
    />
  )
}
